<footer class="ds-footer footer-style">
  <h2 class="visually-hidden">intestazione footer</h2>

  <div class="ds-footer__logos footer-logo-copy">
    <div class="ds-footer__logo">
      <img src="/assets/images/logoSnam.svg" alt="Logo Snam" />
    </div>
    <p>
      <span>&#169;</span> 2026 Snam S.p.A. -
      {{ "Footer.PartitaIVA" | translate }}: 13271390158
    </p>
  </div>

  <div class="ds-footer__upper-section footer-links">
    <h3 class="visually-hidden">link utili</h3>
    <ds-textlink
      [attr.textlink-text-size]="'body1'"
      [attr.textlink-neutral]="true"
      [attr.textlink-url]="'https://www.snam.it/it/accessibilita.html'"
      [attr.textlink-text]="'Footer.Accessibilita' | translate"
      [attr.textlink-weight]="'w700'"
      [attr.icon]="'icon-arrow-up-right'"
      [attr.icon-position]="'right'"
      [attr.textlink-aria-label]="'https://www.snam.it/it/accessibilita.html'"
      [attr.is-external-link]="true"
      [attr.textlink-stop-animation]="true"
    ></ds-textlink>
    <ds-textlink
      [attr.textlink-text-size]="'body1'"
      [attr.textlink-neutral]="true"
      [attr.textlink-url]="'https://www.snam.it/it/disclaimer.html'"
      [attr.textlink-text]="'Footer.Privacy' | translate"
      [attr.textlink-weight]="'w700'"
      [attr.icon]="'icon-arrow-up-right'"
      [attr.icon-position]="'right'"
      [attr.textlink-aria-label]="'https://www.snam.it/it/disclaimer.html'"
      [attr.is-external-link]="true"
      [attr.textlink-stop-animation]="true"
    ></ds-textlink>
    <ds-textlink
      [attr.textlink-text-size]="'body1'"
      [attr.textlink-neutral]="true"
      [attr.textlink-url]="'https://www.snam.it/it/legal-disclaimer.html'"
      [attr.textlink-text]="'Footer.LegalDisclaimer' | translate"
      [attr.textlink-weight]="'w700'"
      [attr.icon]="'icon-arrow-up-right'"
      [attr.icon-position]="'right'"
      [attr.textlink-aria-label]="
        'https://www.snam.it/it/legal-disclaimer.html'
      "
      [attr.is-external-link]="true"
      [attr.textlink-stop-animation]="true"
    ></ds-textlink>
    <ds-textlink
      [attr.textlink-text-size]="'body1'"
      [attr.textlink-neutral]="true"
      [attr.textlink-url]="'https://www.snam.it/it/supporto-e-contatti.html'"
      [attr.textlink-text]="'Footer.Aiuto' | translate"
      [attr.textlink-weight]="'w700'"
      [attr.icon]="'icon-arrow-up-right'"
      [attr.icon-position]="'right'"
      [attr.textlink-aria-label]="
        'https://www.snam.it/it/supporto-e-contatti.html'
      "
      [attr.is-external-link]="true"
      [attr.textlink-stop-animation]="true"
    ></ds-textlink>
  </div>
</footer>
